import React, { Component} from "react";
import { withRouter, Redirect} from "react-router-dom";
import { clear, set, get } from "services/storage";
import { installMetaPixel, installGoogleTag, installMicrosoftClarity } from "utils/utils";
import { unconnected_api_get, log_js_error} from "services/cms/api";
import axios from "axios";
const instance = axios.create({ baseURL: process.env.REACT_APP_URL_CMS });
const base_url = process.env.REACT_APP_URL_CMS;
class LayoutUnconnectedSystem extends Component {
  constructor(props) {
    super(props);
    this.user = get("session_user");
    let params = new URLSearchParams(props.location.search);
    var school_id_target = props.match.params.school_id || params.get("school_id");
    if(!school_id_target && (window.location.pathname.indexOf("inscription-madina-schools/") > -1 || window.location.pathname.indexOf("inscription-madina-schools-merci/") > -1)){
      if(false && window.location.host.indexOf("localhost") > -1){
        school_id_target = "gAAAAABisg8PH5ax77RHO6H24_Nv24I1ZGkPwMlrL23J5tRVpPH_KR90rJ5IjCdvuGcc6OgwEcBk2OhPNgKjiGs1jbDfvg7NEA==";
      }
      else {
        school_id_target = "gAAAAABlZ0AsDrBQs3z3PrX8fJDgAlDWKz8FjPWGGZZ3zTjshYHYOhO0BhVvOZ06YZ47-fvUJgz3c7kWQka5BbGysegHyH3zsw==";
      }
    }
    this.state = {
      school_id_target: school_id_target,
      school_target: null,
      all_schools_targets: [],
      data_loaded: false,
      target_school_style: window.location.pathname.indexOf("inscription-madina-schools/") > -1 || window.location.pathname.indexOf("inscription-madina-schools-merci/") > -1 || window.active_style_2 ? 2 : 1,
    };
    this.getSchoolTargetData(school_id_target);
  }

  componentWillReceiveProps(props){
    let params = new URLSearchParams(props.location.search);
    let school_id_target_ = props.match.params.school_id || params.get("school_id");
    if(!school_id_target_ && (window.location.pathname.indexOf("inscription-madina-schools/") > -1 || window.location.pathname.indexOf("inscription-madina-schools-merci/") > -1)){
      if(false && window.location.host.indexOf("localhost") > -1){
        school_id_target_ = "gAAAAABisg8PH5ax77RHO6H24_Nv24I1ZGkPwMlrL23J5tRVpPH_KR90rJ5IjCdvuGcc6OgwEcBk2OhPNgKjiGs1jbDfvg7NEA==";
      }
      else {
        school_id_target_ = "gAAAAABlZ0AsDrBQs3z3PrX8fJDgAlDWKz8FjPWGGZZ3zTjshYHYOhO0BhVvOZ06YZ47-fvUJgz3c7kWQka5BbGysegHyH3zsw==";
      }
    }
    if(school_id_target_ && this.state.school_id_target != school_id_target_){
      var school_id_target = school_id_target_;
      this.getSchoolTargetData(school_id_target);
      this.state = {
        school_id_target: school_id_target,
      };
    }
  }

  componentDidCatch(error, info) {
    // this.props.history.push('/ErrorPage');
    // var data={
    //   error_stack: error.stack,
    // }
    // log_js_error(data);
  }

  componentDidMount(){
  }

  getSchoolTargetData = school_id => {
    if(school_id && !window.api_sent){
      window.api_sent = true;
      var data = {
        school_id: school_id,
        action: "get_target_school",
      };
      var this_ = this;
      unconnected_api_get(data).then(res => {
        window.api_sent = false;
        if(res.success){
          this_.setState({
            school_target: res.school_target,
            all_schools_targets: res.all_schools_targets,
            current_scholar_year: res.selected_scholar_year,
            next_scholar_year: res.next_scholar_year,
          });
          if(res.school_target && res.school_target.meta_pixel_id){
            installMetaPixel(res.school_target.meta_pixel_id);
          }
          if(res.school_target && res.school_target.google_tag_id){
            installGoogleTag(res.school_target.google_tag_id, window.location.pathname.indexOf("inscription-madina-schools-merci/") > -1);
          }
          if(res.school_target && res.school_target.clarity_project_id){
            installMicrosoftClarity(res.school_target.clarity_project_id);
          }
        }
      })
      var data2 = {
        school_id: school_id,
        action: "get_target_school_style",
      };
      unconnected_api_get(data2).then(res => {
        if(res.success){
          this_.setState({
            target_school_style: window.location.pathname.indexOf("inscription-madina-schools/") > -1 || window.location.pathname.indexOf("inscription-madina-schools-merci/") > -1 || window.active_style_2 ? 2 : res.target_school_style,
          });
        }
      })
    }
  }

  render() {
    const { Layout, Component } = this.props;
    const {school_target, school_id_target} = this.state;
  return (
      <Layout 
        
      >
        <Component
          {...this.props}
          global_data={this.state}
        />
      </Layout>
    );
  }
};

export default withRouter(LayoutUnconnectedSystem);
